import './Select.sass'

import * as React from 'react'
import Select from 'react-select'
import { CustomSelectProps, CustomSelectStateProps } from './'
import { isMobile } from '../../utils/helpers'

export class CustomSelect extends React.Component<CustomSelectProps, CustomSelectStateProps> {
  state = {
    focused: false
  }

  constructor(props: CustomSelectProps) {
    super(props)

    this.handleBlur = this.handleBlur.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
  }

  handleBlur () {
    const { onBlur, name } = this.props

    onBlur(name, true)
    this.setState({ focused: false })
  }

  handleFocus () {
    this.setState({ focused: true })
  }

  render () {
    const {
      options,
      placeholder,
      error,
      touched,
      label,
      ...props
    } = this.props

    const { focused } = this.state

    const getLabelClass = (): string => {
      if(error && touched) {
        return 'error'
      } else if (focused) {
        return  'active'
      }

      return ''
    }

    return (
      <div className='select-field-wrapper'>
        <label className={getLabelClass()}>{label}</label>
        <Select
          styles={customStyles(error, touched)}
          options={options}
          placeholder={placeholder}
          isSearchable={true}
          onChange={(value) => props.onChange(props.name, value)}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
        />
      </div>
    )
  }
}

const fontStyles = {
  fontSize: '18px',
  fontWeight: 400,
  marginLeft: 0
}
const colorFormBg = '#fff'

const customStyles = (error: string | undefined, touched: boolean | undefined) => ({
  container: () => ({
    position: 'relative',
    height: '46px',
    boxSizing: 'borderBox',
  }),
  input: () => ({
    margin: 0
  }),
  menu: (base: any) => ({
    ...base,
    marginTop: 9,
    paddingTop: 13,
    paddingBottom: 13,
    borderRadius: 15,
    backgroundColor: colorFormBg,
    border: '1px solid #44465c'
  }),
  control: (base: any, state: any) => {
    const border = () => {
      if (state.isFocused) {
        return 'solid 1px #5b58fb'
      }
      return 'none'
    }

    return {
      ...base,
      padding: '8px 16px',
      borderRadius: '4px',
      border: border(),
      backgroundColor: '#edeef3',
      minHeight: '30px',
      cursor: 'pointer',
      boxSizing: 'borderBox',
      boxShadow: 0,
      '&:hover': {
        border: border(),
        outline: 'none'
      }
    }
  },
  option: (base: any, state: any) => ({
    ...base,
    ...fontStyles,
    fontWeight: state.isSelected ? 600 : 300,
    paddingLeft: 30,
    backgroundColor: state.isSelected ? '#edeef3' : colorFormBg,
    cursor: 'pointer',
    paddingTop: 10,
    color: '#44465c',
    paddingBottom: 10,
    '&:hover': {
      fontWeight: 600
    },
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  valueContainer: (provided, state) => ({
    padding: 0,
    lineHeight: '30px'
  }),
  dropdownIndicator: (base: any, state: any) => {
    const color = '#8f97b1'

    return ({
      ...base,
      color,
      padding: '0 8px',
      paddingRight: 0,
      '&:active': {
        color
      }
    })
  },
  singleValue: (base: any) => ({
    ...base,
    color: '#000',
    ...fontStyles
  }),
  placeholder: (base: any) => ({
    ...base,
    ...fontStyles,
    color: '#555555',
    opacity: 0.54,
    fontSize: '18px'
  })
})
